import React from 'react'
import CommonProject from '../CommonComponent/CommonProject'

export default function Projects() {
  return (
    <>
    <div className="teamSpace"></div>
      <CommonProject/>
    </>
  )
}
